import { deleteApi, getApi, postApi, postUpdateApi } from 'util/api';
import { omit } from 'ramda';
import { PAYRAILZ_ADMIN_ORG_ID } from './index';

const ADMINUSERS_AUTH_BASE_URI = '/auth/adminusers';

export const addUser = (data) => {
  // Ontrac defines userLogin === email
  data.email = data.userLogin;
  return postApi(ADMINUSERS_AUTH_BASE_URI, data);
};

export const deleteUser = ({ id }) =>
  deleteApi(ADMINUSERS_AUTH_BASE_URI, { id });

export const loadUsers = (params, auth) => {
  if (auth.adminOrg.id === PAYRAILZ_ADMIN_ORG_ID) {
    return queryTopLevelUsers(params);
  }
  return getApi(
    `${ADMINUSERS_AUTH_BASE_URI}/${auth.id}/users`,
    omit(['id'], params)
  );
};

const queryTopLevelUsers = (params) => getApi(ADMINUSERS_AUTH_BASE_URI, params);

export const loadTypeAhead = queryTopLevelUsers;

export const loadByOrgId = queryTopLevelUsers;

export const loadUser = queryTopLevelUsers;

export const updateUser = ({ id, ...data }) =>
  postUpdateApi(ADMINUSERS_AUTH_BASE_URI, { id, ...data });

export const updateUserStatus = ({ id, status }) =>
  postApi(`${ADMINUSERS_AUTH_BASE_URI}/${id}/updatestatus`, {
    userStatus: status,
  });
